import { Component, Inject, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { ModalService } from 'apps/account/src/account-shared';
import { buildCnameUrl } from 'apps/account/src/account-shared/pipes/cname-url.util';
import { Environment, ENVIRONMENT_TOKEN } from 'account-hybrid/core/environment.service';
import { UrlFormatter } from 'shared';
import dayjs from 'dayjs/esm/index';
import { map, take, tap } from 'rxjs/operators';
import { PhotoContestThemes, PhotoContestThemesToInviteSuffix } from '../../../common/models/photo-contest-themes';
import { ContestInviteSetupOptions } from '../short-url-wizard/setup-options';
import { ShortUrlService } from '../short-urls.service';
import { IdentityService } from 'account-hybrid/core/authentication';

const enureSimpleChangeArgument = (argument: SimpleChange) => !!argument && !!argument.currentValue;

@Component({
    selector: 'ft-short-url-list',
    templateUrl: './short-url-list.component.html',
    styleUrls: ['./short-url-list.component.css'],
    inputs: [
        'themeName',
        'companyCode',
        'propertyUuid',
        'propertySlug',
        'contestUuid',
        'subdomains'
    ],
    standalone: false
})
export class ShortUrlListComponent implements OnInit, OnChanges {

    themeName: string;
    companyCode: string;
    propertyUuid: string;
    propertySlug: string;
    contestUuid: string;
    subdomains: any;

    links: object[];
    setupOptions: ContestInviteSetupOptions;
    links$: any;

    isFliptoStaff = this.identityService.isFliptoStaff();

    constructor(
        private shortUrls: ShortUrlService,
        private modalService: ModalService,
        private identityService: IdentityService,
        @Inject(ENVIRONMENT_TOKEN) private environment: Environment
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: { [key in keyof ShortUrlListComponent]: SimpleChange }): void {
        if (enureSimpleChangeArgument(changes.themeName) &&
            enureSimpleChangeArgument(changes.propertyUuid) &&
            // enureSimpleChangeArgument(changes.contestUuid) &&
            enureSimpleChangeArgument(changes.subdomains)) {
            this.links$ = this.getShorUrlsForThemedContestInvite();
        }
    }

    getShorUrlsForThemedContestInvite() {
        const contestInviteUrl = buildCnameUrl(this.subdomains, 3, this.propertySlug, undefined, this.environment.FliptoHubDomain);
        this.setupOptions = {
            companyCode: this.companyCode,
            propertyUuid: this.propertyUuid,
            contestUuid: this.contestUuid,
            theme: PhotoContestThemes[this.themeName],
            baseUrl: UrlFormatter.combineUrlPath(contestInviteUrl, PhotoContestThemesToInviteSuffix.get(PhotoContestThemes[this.themeName]))
        } as ContestInviteSetupOptions;
        return this.shortUrls
            .getAllShortUrls(
                this.propertyUuid,
                PhotoContestThemes[this.themeName],
                this.contestUuid
            )
            .pipe(
                take(1),
                map(shortUrls => shortUrls.sort((a: any, b: any) => dayjs(b.createDate).unix() - dayjs(a.createDate).unix())),
                tap(shortUrls => shortUrls.forEach(url => url.displayName = url.displayName || '<Existing link>'))
            );
    }

    onShortUrlWizardComplete() {
        this.links$ = this.getShorUrlsForThemedContestInvite()
            .pipe(
                tap(() => {
                    this.modalService.hide('photoContest.newShortUrl');
                })
            );
    }
}
